import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.FaNews = class FaNews extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-news';
    }

    constructor(element) {
        super(element);
    }

    render() {
        $('document').ready(function () {
            console.log("hello Ravi")
        })

        $('.js-content-filter').change(function () {
            var options = {
                someAttribute: $(this).attr('some-attribute'), //if necessary
            };
            someFunction(options);

        });

        function someFunction(options) {
            var defaults = {};
            var settings = $.extend(options, defaults);

            console.log("do-something")
            //do something
            
        };

        
        
    };
 

}






// WEBPACK FOOTER //
// ./components/faNews/scripts/fa-news.js